<mat-card class="ver-body-dialog">
  <app-card-header
    [title]="'Detalle del reenvío'"
    [subtitle]="entidad"
    icono="article"
    [botonAccion]="{
      icon: copiado === 'todo' ? 'check' : 'data_object',
      tooltip:
        copiado === 'todo'
          ? 'Copiado'
          : 'Copiar JSON: destino, método, headers, body y resultado',
    }"
    (accion)="copiar('todo')"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <!-- Resumen -->
    <app-content-card title="Resumen" icon="info">
      <div class="vb-datos">
        <span class="vb-etiqueta">Fecha</span>
        <span class="vb-valor">
          {{ log.fecha | date: 'dd/MM/yyyy HH:mm:ss' }}
        </span>

        <span class="vb-etiqueta">Entidad</span>
        @if (entidad) {
          <span class="vb-valor">{{ entidad }}</span>
        } @else {
          <span class="no-info">Sin entidad</span>
        }

        @if (log.protocolo) {
          <span class="vb-etiqueta">Tipo</span>
          <span class="vb-valor">{{ log.protocolo }}</span>
        }

        <span class="vb-etiqueta">Destino</span>
        <span class="vb-valor vb-destino">
          @if (log.metodoHttp) {
            <strong class="vb-metodo">{{ log.metodoHttp }}</strong>
          }
          @if (destino) {
            <span>{{ destino }}</span>
          } @else {
            <span class="no-info">Sin destino</span>
          }
        </span>

        @if (respuestaStatus != null) {
          <span class="vb-etiqueta">HTTP</span>
          <span class="vb-valor">
            <span class="vb-status" [class]="claseStatus">
              {{ respuestaStatus }}
            </span>
          </span>
        }

        <span class="vb-etiqueta">Resultado</span>
        <span class="vb-valor vb-resultado" [class.vb-rechazado]="!log.ack">
          <mat-icon>{{ log.ack ? 'check_circle' : 'error' }}</mat-icon>
          {{ log.ack ? 'Aceptado' : log.error || 'Rechazado' }}
        </span>
      </div>
    </app-content-card>

    @if (esHttp) {
      <app-content-card title="Headers" icon="list_alt">
        @if (headers.length) {
          <button
            irxBotonIcono
            card-header-actions
            type="button"
            [tooltip]="
              copiado === 'headers' ? 'Copiado' : 'Copiar headers (JSON)'
            "
            (click)="copiar('headers')"
          >
            <mat-icon>
              {{ copiado === 'headers' ? 'check' : 'content_copy' }}
            </mat-icon>
          </button>
        }
        @if (headers.length) {
          <div class="vb-codigo vb-headers">
            @for (h of headers; track h[0]) {
              <div class="vb-header-fila">
                <span class="vb-header-nombre">{{ h[0] }}:</span>
                <span class="vb-header-valor">{{ h[1] }}</span>
              </div>
            }
          </div>
        } @else {
          <span class="no-info">
            Sin headers registrados (logs anteriores a que se guardaran)
          </span>
        }
      </app-content-card>
    }

    <app-content-card title="Body" icon="data_object">
      @if (body) {
        <button
          irxBotonIcono
          card-header-actions
          type="button"
          [tooltip]="copiado === 'body' ? 'Copiado' : 'Copiar body'"
          (click)="copiar('body')"
        >
          <mat-icon>
            {{ copiado === 'body' ? 'check' : 'content_copy' }}
          </mat-icon>
        </button>
      }
      @if (!body) {
        <span class="no-info">Sin body</span>
      } @else if (parsedJson !== null) {
        <div class="vb-codigo">
          <app-json-tree
            [data]="parsedJson"
            [expanded]="expandido"
          ></app-json-tree>
        </div>
      } @else {
        <pre class="vb-codigo vb-texto">{{ formattedBody }}</pre>
      }
    </app-content-card>

    @if (esHttp) {
      <app-content-card
        [title]="
          respuestaStatus != null
            ? 'Respuesta (HTTP ' + respuestaStatus + ')'
            : 'Respuesta'
        "
        icon="reply"
      >
        @if (respuesta) {
          <button
            irxBotonIcono
            card-header-actions
            type="button"
            [tooltip]="
              copiado === 'respuesta' ? 'Copiado' : 'Copiar respuesta'
            "
            (click)="copiar('respuesta')"
          >
            <mat-icon>
              {{ copiado === 'respuesta' ? 'check' : 'content_copy' }}
            </mat-icon>
          </button>
        }
        @if (respuestaStatus == null && !respuesta) {
          <span class="no-info">
            Sin respuesta registrada (el request no llegó a salir, o es un log
            anterior a que se guardara)
          </span>
        } @else if (!respuesta) {
          <span class="no-info">Respuesta sin cuerpo</span>
        } @else if (respuestaJson !== null) {
          <div class="vb-codigo">
            <app-json-tree
              [data]="respuestaJson"
              [expanded]="expandidoRespuesta"
            ></app-json-tree>
          </div>
        } @else {
          <pre class="vb-codigo vb-texto">{{ respuestaTexto }}</pre>
        }
      </app-content-card>
    }
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="cerrar()">Cerrar</button>
  </mat-card-actions>
</mat-card>
